export interface RequestGetOrganicAd<Type extends ObjectiveType> {
  objectiveType: Type
  objectiveId: Objective<Type>['id']
}

export interface RequestGetOrganicAds<Type extends ObjectiveType> {
  filter: {
    objectiveType: Type
    objectiveTargetCountries: TargetCountry[]
    exposureAvailability: ExposureAvailability | null
    isDailyBudgetExhausted: boolean | null
  }
  pagination: {
    pageIndex: number
    pageSize: number
  }
}

export interface ResponseGetOrganicAds<Type extends ObjectiveType> {
  totalPageNumber: number
  currentPageIndex: number
  pageSize: number
  isLastPage: boolean
  totalElementNumber: number
  contents: OrganicAd<Type>[]
}

export interface OrganicAd<Type extends ObjectiveType> {
  objective: Objective<Type>
  hospitalId: number
  dailyBudget: DailyBudget
  exposureAvailability: ExposureAvailability
}

export interface RequestSetDailyBudget<Type extends ObjectiveType> {
  objectiveType: Type
  objectiveId: Objective<Type>['id']
  dailyBudgetAmount: number | null
}

export interface Objective<Type extends ObjectiveType> {
  id: number
  name: string
  type: Type
  targetCountry: TargetCountry
}

export interface DailyBudget {
  date: string
  amount: number | null
  spendingAmount: number
}

export enum ObjectiveType {
  SERVICE_OFFER = 'SERVICE_OFFER',
  DOCTOR = 'DOCTOR',
  HOSPITAL = 'HOSPITAL',
}

export enum ExposureAvailability {
  AVAILABLE = 'AVAILABLE',
  PAUSED = 'PAUSED',
}

export enum TargetCountry {
  KR = 'KR',
  JP = 'JP',
  TH = 'TH',
  EN = 'ZZ',
}
